import { Table, Avatar, Tag, Button } from "antd";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";

function TopLeaderBoard({ searchText }) {
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });

  const fetchData = (paginationParams) => {
    setLoading(true);
    const params = new URLSearchParams();

    if (searchText) {
      params.append("search", searchText);
    }

    params.append("page", paginationParams.current);
    params.append("limit", paginationParams.pageSize);

    request({
      url: `${apiPath.topLeaderBoard}?${params.toString()}`,
      method: "GET",
      onSuccess: ({ data }) => {
        setLoading(false);
        setList(data?.data || []);
        setPagination({
          current: data?.pagination?.page || paginationParams.current,
          total: data?.pagination?.totalUsers || 0,
          pageSize: Number(data?.pagination?.limit) || 10,
        });
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error?.response?.data?.message || "Failed to fetch data", Severty.ERROR);
      },
    });
  };

  useEffect(() => {
    fetchData(pagination);
  }, [searchText]);

  const handleChange = (newPagination) => {
    fetchData(newPagination);
  };

  const columns = [
    {
      title: "Rank",
      key: "rank",
      width: "5%",
      render: (_, record) => {
        const rank = record?.rank;
        if (rank === 1) return <strong style={{ color: '#FFD700', fontSize: '18px' }}>🥇 1</strong>;
        if (rank === 2) return <strong style={{ color: '#C0C0C0', fontSize: '18px' }}>🥈 2</strong>;
        if (rank === 3) return <strong style={{ color: '#CD7F32', fontSize: '18px' }}>🥉 3</strong>;
        return <strong>#{rank || "-"}</strong>;
      },
    },
    {
      title: "User Info",
      key: "user",
      width: "25%",
      render: (_, record) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Avatar src={record?.avatar} size="large">
            {record?.name?.charAt(0)?.toUpperCase()}
          </Avatar>
          <div>
            <div style={{ fontWeight: 600, fontSize: "14px" }}>{record?.name || "-"}</div>
            <div style={{ fontSize: "12px", color: "gray" }}>@{record?.username || "-"}</div>
          </div>
        </div>
      ),
    },
    {
      title: "Role & Badges",
      key: "role",
      width: "15%",
      render: (_, record) => (
        <div>
          {record?.cricketRole?.name && (
            <Tag color="blue" style={{ marginBottom: '4px' }}>
              {record.cricketRole.name}
            </Tag>
          )}
          {record?.badges?.map((badge) => (
            <Tag color="gold" key={badge._id} style={{ marginBottom: '4px', marginLeft: '4px' }}>
              {badge.name}
            </Tag>
          ))}
          {!record?.cricketRole?.name && (!record?.badges || record.badges.length === 0) && "-"}
        </div>
      ),
    },
    {
      title: "Skills",
      key: "skills",
      width: "25%",
      render: (_, record) => (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
          {record?.skillTags?.length > 0 ? (
            record.skillTags.map((skill) => (
              <Tag color="cyan" key={skill._id}>
                {skill.name} ({skill.count})
              </Tag>
            ))
          ) : (
            "-"
          )}
        </div>
      ),
    },
    {
      title: "Leaderboard Points & Engagement",
      key: "points",
      width: "20%",
      render: (_, record) => (
        <div>
          <div style={{ fontWeight: 'bold', fontSize: "15px", color: "#1890ff" }}>
            {record?.totalTPS || 0} TPS
          </div>
          <div style={{ fontSize: "12px", color: "gray", marginTop: "4px" }}>
            Engagement: {record?.totalEngagement || 0}
          </div>
        </div>
      ),
    },
    {
      title: "Action",
      key: "action",
      width: "10%",
      render: (_, record) => (
        <Link to={`/admin/user-manager/view/${record?.userId}`}>
          <Button type="primary" size="small">
            View
          </Button>
        </Link>
      ),
    },
  ];

  return (
    <div className="table-responsive customPagination customPaginationmain-newwwww">
      <Table
        loading={loading}
        columns={columns}
        dataSource={list}
        rowKey={(record) => record.userId || record._id || record.id || Math.random()}
        pagination={{
          current: pagination.current,
          defaultPageSize: 10,
          responsive: true,
          total: pagination.total,
          showSizeChanger: true,
          showQuickJumper: true,
          pageSizeOptions: ["10", "20", "30", "50"],
        }}
        onChange={handleChange}
        className="ant-border-space"
      />
    </div>
  );
}

export default TopLeaderBoard;
